// import React, { useState } from "react"
// import NavFront from "./NavFront";
// import Sidebar from "./Sidebar";
// import Main from "./Main";
// import { auth } from '../../../firebase';
// import SignInDialog from '../Folios/SignInDialog';
// import Onboardings from "../../layouts/First";
// import Second from '../../layouts/SecondModal';
// import Third from '../../layouts/ThirdModal';
// import Search from './Search';
// import { makeStyles } from '@material-ui/core/styles';
// import Drawer from '@material-ui/core/Drawer';
// import AppBar from '@material-ui/core/AppBar';
// import CssBaseline from '@material-ui/core/CssBaseline';
// import Toolbar from '@material-ui/core/Toolbar';
// import List from '@material-ui/core/List';
// import Typography from '@material-ui/core/Typography';
// import Divider from '@material-ui/core/Divider';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';
// import styled from "styled-components";
// import { ParaA } from "../SignIn";
// import more from "../../../assets/more.svg"
// import { Link, useHistory } from "react-router-dom";

// const Front = (props) => {
//   const user = auth.currentUser;
//   if (localStorage.getItem('startexperience') === '1') {
//     window.scrollTo(0, 0);
//     localStorage.removeItem('startexperience');
//   }
//   let uid = 'empty';
//   if (user) {
//     uid = user.uid;
//     console.log(auth.currentUser.emailVerified, 'emailverify');
//   }
//   const category = props.location.category;
//   const [focused, setfocused] = useState(false);
//   const [searchtext, setsearchtext] = useState('');
//   const [searchtype, setsearchtype] = useState([]);
//   const [navClick, setnavClick] = useState(false);
//   const [allposts, setallposts] = useState([]);
//   const [exacttitle, setexacttitle] = useState('');
//   const [searchtitle, setsearchtitle] = useState([]);
//   const [searchClicked, setsearchClicked] = useState(false);
//   const history = useHistory();
//   const logOut = () => {
//     auth.signOut();
//     localStorage.removeItem("user");
//     history.push("/");
//     localStorage.setItem("allowed", "0");
//     localStorage.setItem("signup", "0");
//   };
//   // const drawerWidth = 300;

//   const useStyles = makeStyles((theme) => ({
//     root: {
//       display: 'flex',
//     },
//     appBar: {
//       // zIndex: theme.zIndex.drawer + 1,
//     },
//     drawer: {
//       // width: drawerWidth,
//       // flexShrink: 0,
//     },
//     drawerPaper: {
//       // width: drawerWidth,
//     },
//     elevation4: {
//       // boxShadow: "none !important",
//     },
//     // drawerContainer: {
//     //   overflow: 'auto',
//     // },
//     content: {
//       // flexGrow: 1,
//       // padding: theme.spacing(3),
//     },
//   }));


//   const classes = useStyles();

//   return (
//     <React.Fragment>
//       {localStorage.getItem('signup') === '1' || localStorage.getItem(uid) === 'firsttime' ? <Onboardings uid={uid} /> : null}
//       <div
//         className={classes.root}
//       >
//         <CssBaseline />

//         <AppBar style={{ boxShadow: 'none' }} className={classes.appBar}>

//           <NavFront setnavClick={setnavClick} setsearchClicked={setsearchClicked} setexacttitle={setexacttitle} searchtitle={searchtitle} setsearchtitle={setsearchtitle} user={user} searchtext={searchtext} setsearchtext={setsearchtext} setsearchtype={setsearchtype} />
//           {!searchClicked && searchtext !== '' ? <Search exacttitle={exacttitle} searchtitle={searchtitle} setsearchClicked={setsearchClicked} searchtext={searchtext} searchtype={searchtype} /> : null}

//         </AppBar>


//         <Drawer
//           className={classes.drawer}
//           variant="permanent"
//           classes={{
//             paper: classes.drawerPaper,
//           }}
//         >
//           <Toolbar />
//           <div className={classes.drawerContainer}>
//             <Px>Categories</Px>
//             <Categories>

//               <Link to={{ pathname: '/home', category: 'Geography' }}><Category>Geography</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Physics' }}><CategoryX>Physics</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'History' }}><Category>History</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Spiritual' }}><CategoryX>Spiritual</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Engineering' }}><Category>Engineering</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Psychology' }}><CategoryX>Psychology</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Economics' }}><Category>Economics</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Parenting' }}><CategoryX>Parenting</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Chemistry' }}><Category>Chemistry</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Business' }}><CategoryX>Business</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Mystery' }}><Category>Mystery</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Biology' }}><CategoryX>Biology</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Sociology' }}><Category>Sociology</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Philosophy' }}><CategoryX>Philosophy</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Commerce' }}><Category>Commerce</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Maths' }}><CategoryX>Maths</CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Statistics' }}><Category>Statistics</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Lifestyle' }}><CategoryX>Lifestyle </CategoryX></Link>
//               <Link to={{ pathname: '/home', category: 'Theater' }}><Category>Theater</Category></Link>
//               <Link to={{ pathname: '/home', category: 'Design' }}><CategoryX>Design</CategoryX></Link>
//             </Categories>
//             <div style={{ marginTop: '-4vh', display: 'flex', width: '23vw', marginLeft: '-11vw' }}>
//               <Link to="/all" style={{ textDecoration: "none" }}><Py>All Categories<More style={{ paddingTop: '0.8vh', paddingLeft: '0.5vw' }} /></Py></Link>
//             </div>


//             <Footer>

//               <Left>
//                 <Link onClick={() => { logOut() }} style={{ textDecoration: "none" }}><Pz>Home</Pz></Link>
//                 <Link to="/about" style={{ textDecoration: "none" }}><Pz>About</Pz></Link>
//                 <Link to="/terms" style={{ textDecoration: "none" }}><Pz>Terms and services</Pz></Link>
//               </Left>

//               <Right>
//                 <Link to="/faq" style={{ textDecoration: "none" }}><Pz>FAQ's</Pz></Link>
//                 <Link to="/contact" style={{ textDecoration: "none" }}><Pz>Contact</Pz></Link>
//                 <Link to="/privacy" style={{ textDecoration: "none" }}><Pz>Privacy policy</Pz></Link>

//               </Right>

//             </Footer>

//             <CopyRight>
//               Copyright &#169;2021 Friend a Book
//             </CopyRight>
//           </div>
//         </Drawer>
//         {/* <main className={classes.content}>
//           <Toolbar />
//           <Main setallposts={setallposts} exacttitle={exacttitle} searchClicked={searchClicked} category={category} searchtitle={searchtitle} user={user} navClick={navClick} searchtext={searchtext} setnavClick={setnavClick} />
//         </main> */}
//       </div>
//     </React.Fragment>
//   )
// }
// const Px = styled(ParaA)`
// //     margin-top: 31.4px;
// //     left: -232px;
// //     position:relative;
// //     top: 10.725px;
// //     font-weight:400;
// //     font-family: Rubik;
// //     font-style: normal;
// //     font-weight: normal;
// //     font-size: 18px;
// //     line-height: 23px;

// // color: #000000;
// `;
// const Py = styled(Px)`
//     // font-size:13px;
//     // top: 25.74px;
//     // text-align:center;
//     // left: 0px;
// `
// const Pz = styled.p`
//     // position:relative;
//     // left: 14.2px;
//     // right: 13px;
//     // color:black;
//     // margin-bottom: 5.434px;
//     // font-family: Rubik;
//     // font-style: normal;
//     // font-weight: normal;
//     // font-size: 14px;
//     // line-height: 17.875px;
//     // text-align: left;

// `
// const Categories = styled.div`
//     // text-align:center;
//     // position:relative;
//     // top: 19.6px;
//     // display:flex;
//     // flex-direction:row;
//     // flex-wrap:wrap;
//     // justify-content:space-between;
// `;
// const Category = styled.button`

//     // background: #AFAFAF;
//     // border-radius: 0px 100px 100px 0px;
//     // border:none;
//     // width: 137.632px;
//     // height: 43px;
//     // margin-bottom: 10.725px;
//     // font-family: Rubik;
//     // font-style: normal;
//     // font-weight: normal;
//     // font-size: 17px;
//     // line-height: 21.425px;
//     // color: #FFFFFF;
//     // cursor: pointer;
//     // padding-right: 14.212px;
// `;
// const CategoryX = styled(Category)`
//     // border-radius: 100px 0px 0px 100px;
//     // margin-bottom: 10.725px;
//     //     padding-right: 0vw;
// `
// const More = styled.img.attrs(props => ({
//   src: more
// }))`
//     // position:absolute;
//     // margin: 5.434px 5.5px 5.434px 5.4px;
//     // text-align:center;
// `;
// const Footer = styled.div`
//     // position:relative;

//     // //bottom: 7.61vh;
//     // display:flex;
//     // flex-direction:row;
//     // /* align-items:center; */
//     //       /* justify-content:space-between; */
//     //       top:30vh;
//     //     margin: 0.45vh 0.22vw 0.45vh 0.22vw;
//         `;

// const CopyRight = styled(Pz)`

//         // position: relative;
//         // font-size:13px;
//         // top:40vh;
//         // text-align: center;
//         // margin-left: -2vw;
//         // margin-bottom:10px;
//         `
// const Left = styled.div`
//         // display:flex;
//         // flex-direction:column;
//         // text-align:right;
//         // margin-right: 0.07vw
//         `
// const Right = styled(Left)`
//         // margin-left: 1.75vw;
//         `
// export default Front;






import React, { useState } from 'react';
import Main from './Main';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import NavFront from "./NavFront";
import { Link, useHistory } from "react-router-dom";
import CatIcon from '../../../assets/images/caticon.png'
// import Sidebar from "./Sidebar";
// import Main from "./Main";
import { auth } from '../../../firebase';
import SignInDialog from '../Folios/SignInDialog';
import Onboardings from "../../layouts/First";
import Search from './Search';
import Grid from '@material-ui/core/Grid';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
// import Divider from '@material-ui/core/Divider';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';
// import styled from "styled-components";
// import { ParaA } from "../SignIn";
// import more from "../../../assets/more.svg"

const Front = (props) => {
  const user = auth.currentUser;
  if (localStorage.getItem('startexperience') === '1') {
    window.scrollTo(0, 0);
    localStorage.removeItem('startexperience');
  }
  let uid = 'empty';
  if (user) {
    uid = user.uid;
    console.log(auth.currentUser.emailVerified, 'emailverify');
  }
  const category = props.location.category;
  const [focused, setfocused] = useState(false);
  const [searchtext, setsearchtext] = useState('');
  const [searchtype, setsearchtype] = useState([]);
  const [navClick, setnavClick] = useState(false);
  const [allposts, setallposts] = useState([]);
  const [exacttitle, setexacttitle] = useState('');
  const [searchtitle, setsearchtitle] = useState([]);
  const [searchClicked, setsearchClicked] = useState(false);
  const history = useHistory();
  const logOut = () => {
    auth.signOut();
    localStorage.removeItem("user");
    history.push("/");
    localStorage.setItem("allowed", "0");
    localStorage.setItem("signup", "0");
  };


  const CategoryList = withStyles((theme) => ({
    root: {
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      // '@media (max-width: 1145px)': {
      //   "margin": "0 20px",
      // },
    }
  }))(List);

  const CategoryListItemOdd = withStyles((theme) => ({
    root: {
      textDecoration: "none",
      background: "#AFAFAF",
      borderRadius: "0px 100px 100px 0px",
      border: "none",
      width: "137.632px",
      height: "43px",
      marginBottom: "10.725px",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "17px",
      lineHeight: "21.425px",
      color: "#FFFFFF",
      cursor: "pointer",
      paddingRight: "14.212px",
      justifyContent: "center",
      '@media (max-width: 950px)': {
        width: "105px",
        fontSize: "15px",
      },
    }
  }))(ListItem);
  const CategoryListItemEven = withStyles((theme) => ({
    root: {
      textDecoration: "none",
      background: "#AFAFAF",
      borderRadius: "100px 0px 0px 100px",
      border: "none",
      width: "137.632px",
      height: "43px",
      marginBottom: "10.725px",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "17px",
      lineHeight: "21.425px",
      color: "#FFFFFF",
      cursor: "pointer",
      paddingRight: "14.212px",
      justifyContent: "center",
      '@media (max-width: 950px)': {
        width: "105px",
        fontSize: "15px",
      },
    }
  }))(ListItem);



  const drawerWidth = 300;

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      fontFamily: "Rubik"
    },
    drawer: {
      marginTop: "500px",
      width: drawerWidth,
      flexShrink: 0,
      fontFamily: "Rubik",
      '@media (max-width: 950px)': {
        width: "230px",
      },
      '@media (max-width: 730px)': {
        width: "0px",
      },
    },
    appBar: {
      // display: "none",
      // visibility: "hidden",
      marginTop: "90px",
      marginLeft: "5px",
      width: "35px",
      height: "35px",
      display: "flex",
      justifyContent: "center",
      right: "0",
      left: "0",
      boxShadow: "none",
      background: "transparent",
      boxShadow: "none",
      backgroundColor: "transparent",
      // [theme.breakpoints.up('sm')]: {
      //   // display: "block",
      //   // visibility: "show",
      //   width: `calc(100% - ${drawerWidth}px)`,
      //   marginLeft: drawerWidth,
      //   // backgroundColor: "transparent",
      //   boxShadow: "none",
      // },
      // '&:hover': {
      //   opacity: "100%",
      //   transition: "0.8s",
      // },
    },
    menuButton: {
      // marginRight: theme.spacing(1),
      width: "15px",
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    drawerPaper: {
      marginTop: "88px",
      paddingBottom: "90px",
      width: drawerWidth,
      fontFamily: 'Rubik',
      // '@media (max-width: 955px)': {
      //   width: `calc(${drawerWidth}px - 50px)`,
      // },
      '@media (max-width: 950px)': {
        width: `calc(${drawerWidth}px - 70px)`,
      },
      '@media (max-width: 730px)': {
        marginTop: "0px",
        paddingTop: "10px",
        paddingBottom: "0px",
        width: `calc(${drawerWidth}px - 30px)`,
      },

    },
    content: {
      marginTop: "85px",
      fontFamily: 'Rubik',
      flexGrow: 1,
      padding: "24px 24px 24px 24px",
      '@media (max-width: 797px)': {
        padding: "24px 0px 24px 0px",
      },
      '@media (max-width: 395px)': {
        padding: "24px 0px 24px 0px",
      },
    },
    link: {
      textDecoration: 'none',
      color: "black",
      cursor: "pointer",
      '&:hover': {
        textDecoration: 'none',
        // color: "black"
      },
      '@media (max-width: 950px)': {
        fontSize: "12.8px",
      },
    },
    footer: {
      margin: "214.5px 0px 30px 0px",
      paddingLeft: "24px",
      fontSize: "13px",
      '@media (max-width: 950px)': {
        paddingLeft: "16px",
        fontSize: "12px",
      },
    },
    copyright: {
      textAlign: "center",
      fontSize: "13px",
      '@media (max-width: 950px)': {
        fontSize: "11px",
      },
    }
  }));

  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div><h5 style={{ margin: "20px 0 10px 10px" }}>Categories</h5></div>

      <CategoryList>

        <Link to={{ pathname: '/home', category: 'Geography' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Geography</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Physics' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Physics</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'History' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>History</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Spiritual' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Spiritual</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Engineering' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Engineering</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Psychology' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Psychology</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Economics' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Economics</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Parenting' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Parenting</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Chemistry' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Chemistry</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Business' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Business</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Mystery' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Mystery</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Biology' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Biology</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Sociology' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Sociology</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Philosophy' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Philosophy</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Commerce' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Commerce</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Maths' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Maths</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Statistics' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Statistics</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Lifestyle' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Lifestyle </CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Theater' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Theater</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Design' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Design</CategoryListItemEven>
        </Link>

      </CategoryList>

      <div style={{ textAlign: "center", fontSize: "13px" }}>
        <Link to="/all" className={classes.link} style={{ cursor: "pointer" }}>All Categories<ChevronRightRoundedIcon style={{ fontSize: "18px" }} /></Link>
      </div>

      <div className={classes.footer}>
        <Grid container spacing={1} >
          <Grid item xs={6}>
            <Link onClick={() => { logOut() }} className={classes.link} style={{ cursor: "pointer" }}><text>Home</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/about" className={classes.link} style={{ cursor: "pointer" }}><text>About</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/terms" className={classes.link} style={{ cursor: "pointer" }}><text>Terms and Service</text></Link>
          </Grid>

          <Grid item xs={6}>
            <Link to="/faq" className={classes.link} style={{ cursor: "pointer" }}><text>FAQ’s</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/contact" className={classes.link} style={{ cursor: "pointer" }}><text>Contact</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/privacy" className={classes.link} style={{ cursor: "pointer" }}><text>Privacy Policy</text></Link>
          </Grid>

        </Grid>
      </div>
      <div className={classes.copyright}>
        Copyright &#169;2021 Friend a Book
        <br/>
        Made with 💖 by <a target='_blank' href="https://github.com/Priyanka-Chatterjee-2000">Pri</a>
      </div>
    </div >
  );



  return (
    <React.Fragment>
      {localStorage.getItem('signup') === '1' || localStorage.getItem(uid) === 'firsttime' ? <Onboardings uid={uid} /> : null}
      <div>
        <NavFront setnavClick={setnavClick} setsearchClicked={setsearchClicked} setexacttitle={setexacttitle} searchtitle={searchtitle} setsearchtitle={setsearchtitle} user={user} searchtext={searchtext} setsearchtext={setsearchtext} setsearchtype={setsearchtype} />
        {!searchClicked && searchtext !== '' ? <Search exacttitle={exacttitle} searchtitle={searchtitle} setsearchClicked={setsearchClicked} searchtext={searchtext} searchtype={searchtype} /> : null}

      </div>

      {/* <div style={{ height: "100vh", background: "red" }}>aaaaaaaaa</div>
      <div style={{ height: "100vh", background: "black" }}>bbbbbbbbbb</div>
      <div style={{ height: "100vh", background: "green" }}>ccccccc</div> */}


      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}>

          <img src={CatIcon} alt=""
            style={{ filter: "drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.1))" }}
            className={classes.menuButton}
            onClick={handleDrawerToggle}
          />

        </AppBar>
        <nav className={classes.drawer} aria-label="mailbox folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              // container={container}
              variant="temporary"
              anchor={theme.direction === 'rtl' ? 'right' : 'left'}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, //Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>
          <Main setallposts={setallposts} exacttitle={exacttitle} searchClicked={searchClicked} category={category} searchtitle={searchtitle} user={user} navClick={navClick} searchtext={searchtext} setnavClick={setnavClick} />
        </main>
      </div>

      {/* <main className={classes.content}>
//           <Toolbar />
//           <Main setallposts={setallposts} exacttitle={exacttitle} searchClicked={searchClicked} category={category} searchtitle={searchtitle} user={user} navClick={navClick} searchtext={searchtext} setnavClick={setnavClick} />
//         </main> */}
    </React.Fragment>
  );
}


export default Front;
